import { render, staticRenderFns } from "./IntesaReport.vue?vue&type=template&id=65e90c6a&scoped=true&"
import script from "./IntesaReport.vue?vue&type=script&lang=js&"
export * from "./IntesaReport.vue?vue&type=script&lang=js&"
import style0 from "./IntesaReport.vue?vue&type=style&index=0&id=65e90c6a&lang=scss&scoped=true&"
import style1 from "./IntesaReport.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e90c6a",
  null
  
)

export default component.exports